export const getCardColor = picture => {
  if (picture && picture.primary) {
    return 'green'
  }

  if (picture && picture.report) {
    return 'red'
  }
}
